import { createSlice } from '@reduxjs/toolkit';

interface IInitialState {
    globalTrigger: number;
    scriptTrigger: number;
    dashboardTrigger: number;
    launchFeatureTrigger: number;
}

const initialState: IInitialState = {
    globalTrigger: 0,
    scriptTrigger: 0,
    dashboardTrigger: 0,
    launchFeatureTrigger: 0
};

const triggerAnythingSlice = createSlice({
    name: 'triggerAnything',
    initialState,
    reducers: {
        triggerAnythingFunc: (state: IInitialState) => {
            state.globalTrigger += 1;
        },

        triggerScriptFunc: (state: IInitialState) => {
            state.scriptTrigger += 1;
        },

        triggerDashboardFunc: (state: IInitialState) => {
            state.dashboardTrigger += 1;
        },

        triggerlaunchFeatureFunc: (state: IInitialState) => {
        state.launchFeatureTrigger += 1;
        },
    },
});

export default triggerAnythingSlice.reducer;
export const { triggerAnythingFunc, triggerScriptFunc, triggerDashboardFunc, triggerlaunchFeatureFunc } = triggerAnythingSlice.actions;
